
import dayjs from "dayjs";

import { scopeTypes, targetTypes } from "../../hooks/useScanData"

const outputFormat = (data) => {

    let a = [];

    Object.keys(data).forEach((i, index) => {
        a.push(`${i}::${data[i]}`)
    })

    // console.log('JSON.stringify(data)', JSON.stringify(data))

    return JSON.stringify(data)
}

export const getQrCodeData = (props) => {

    const {
        id,
        data,
        outputType,
        scopeType,
        targetType
    } = props

    const defaultProps = {
        id,
        ts: dayjs().unix()
    }

    // check is document
    if (scopeType === scopeTypes.document) {

        let docProps = {
            ...defaultProps,
            ta: targetType
        }

        // check target
        // if (targetType === targetTypes.document.deliveryOrder) {

        // console.log('data', data)

        return outputFormat(
            {
                ...docProps,
                va: data?.document?.doc_number,
                // docDate: data?.document?.doc_date,
            }
        )
        // }

    }

    // check is repo
    if (scopeType === scopeTypes.repository) {

        // check target
        if (targetType === targetTypes.repository.package) {
            return outputFormat(
                {
                    ...defaultProps,
                    // data: {
                    // repoNumber: data?.repo_number,
                    // numberAlternative: data?.number_alternative,
                    // repoDate: data?.repo_date,
                    // uomId: data?.uom_id,
                    // uomName: data?.uom_lbl,
                    // locationId: data?.location_id,
                    // locationName: data?.location_name,
                    // packingType: data?.packing_type,
                    // docId: data?.doc_id,
                    // docNumber: data?.doc_number
                    // }
                }
            )
        }

    }

    return outputFormat(
        {
            ...defaultProps
        }
    )
}

export const getBarCodeData = (props) => {

    const {
        id,
        data,
        outputType,
        scopeType,
        targetType
    } = props

    // const defaultProps = {
    //     id,
    //     ts: dayjs().unix()
    // }

    const defaultProps = {}

    // check is document
    if (scopeType === scopeTypes.document) {

        // let docProps = {
        //     ...defaultProps,
        //     ta: targetType
        // }

        // check target
        // if (targetType === targetTypes.document.deliveryOrder) {

        // console.log('data', data)

        // return outputFormat(
        //     {
        //         ...docProps,
        //         va: data?.document?.doc_number,
        //         // docDate: data?.document?.doc_date,
        //     }
        // )
        // }

        return data?.document?.doc_number

    }

    // check is repo
    // if (scopeType === scopeTypes.repository) {

    //     // check target
    //     if (targetType === targetTypes.repository.package) {
    //         return outputFormat(
    //             {
    //                 ...defaultProps,
    //                 // data: {
    //                 // repoNumber: data?.repo_number,
    //                 // numberAlternative: data?.number_alternative,
    //                 // repoDate: data?.repo_date,
    //                 // uomId: data?.uom_id,
    //                 // uomName: data?.uom_lbl,
    //                 // locationId: data?.location_id,
    //                 // locationName: data?.location_name,
    //                 // packingType: data?.packing_type,
    //                 // docId: data?.doc_id,
    //                 // docNumber: data?.doc_number
    //                 // }
    //             }
    //         )
    //     }

    // }

    return outputFormat(
        {
            ...defaultProps
        }
    )
}